import { type UISortOption } from 'src/components/types/UISortOption';
import { type ReduxApplicationState } from 'src/redux/combinedReducer';
import { getSortOptionValue } from 'src/redux/productsQuery/helpers/getSortOptionValue';
import { buildListingsURLFromState } from './state/buildListingsURLFromState';

/**
 * Derives a URL href for each sort option based on current store state.
 * Each href preserves the current facet filters (as path segments) and search
 * term, resets pagination to page 1, and sets the `sort` param for that option
 * (or omits it for the default/empty-key sort option).
 */
export const adaptStoreToSortOptionHrefs = (state: ReduxApplicationState): UISortOption[] => {
  const { sortOptions } = state.productsQuery;

  return sortOptions.map((option) => {
    return {
      active: option.active,
      href: buildListingsURLFromState(state, {
        page: 1,
        sortOption: option.key ? option : null,
      }),
      title: option.title,
      value: getSortOptionValue(option),
    };
  });
};
